export default __webpack_public_path__ + "static/media/pbn2.d8b00082.jpg";